type AuthAccessors = {
  getToken: () => string
  getTokenKey: () => string
  getRefreshToken: () => string
  setToken: (token: string) => void
  setRefreshToken: (token: string) => void
  logout: (message?: string) => void
}

let accessors: AuthAccessors | null = null

export function registerAuthAccessors(authAccessors: AuthAccessors) {
  accessors = authAccessors
}

function getAuthAccessors(): AuthAccessors {
  if (!accessors) {
    throw new Error('[authBridge] Auth accessors not registered')
  }
  return accessors
}

export function getAuthToken(): string {
  return getAuthAccessors().getToken()
}

export function getAuthTokenKey(): string {
  return getAuthAccessors().getTokenKey()
}

export function getAuthRefreshToken(): string {
  return getAuthAccessors().getRefreshToken()
}

export function setAuthToken(token: string) {
  getAuthAccessors().setToken(token)
}

export function setAuthRefreshToken(token: string) {
  getAuthAccessors().setRefreshToken(token)
}

export function authLogout(message?: string) {
  getAuthAccessors().logout(message)
}
